import reducers from './reducers';

export { actions as simpleProductOperations, default as simpleProductSaga } from './operations';

export default reducers;
